import React from 'react';
import { useLocation } from '@/contexts/LocationContext';
import { BoardSelector } from '@/components/common/BoardSelector';
import { logger } from '@/lib/logger';
import { cn } from '@/lib/utils';

interface LocationSelectorProps {
  className?: string;
  showAllOption?: boolean;
  multiSelect?: boolean;
  placeholder?: string;
  onSelectionChange?: (locationIds: string[]) => void;
  showSummary?: boolean;    // NEW: Pass through to BoardSelector
  showSelectAll?: boolean;  // NEW: Pass through to BoardSelector
}

export const LocationSelector: React.FC<LocationSelectorProps> = ({ 
  className = '', 
  showAllOption = true,
  multiSelect = true,
  placeholder = 'Select Locations',
  onSelectionChange,
  showSummary = false,    // Default to false
  showSelectAll = false   // Default to false
}) => {
  const { 
    selectedLocationIds, 
    setSelectedLocationIds,
    locations,
    isLoadingLocations
  } = useLocation();

  // Transform locations to board format
  const locationBoards = locations.map(loc => ({
    id: loc.id,
    name: loc.name
  }));

  // Debug logging
  console.log('🔍 LocationSelector Debug:', {
    locations: locations,
    locationBoards: locationBoards,
    selectedLocationIds: selectedLocationIds,
    isLoadingLocations: isLoadingLocations
  });

  const handleSelectionChange = (ids: string[]) => {
    logger.info('Location selection changed', { ids });
    setSelectedLocationIds(ids);
    if (onSelectionChange) {
      onSelectionChange(ids);
    }
  };

  if (isLoadingLocations) {
    return (
      <div className={`flex items-center gap-2 px-3 py-2 ${className}`}>
        <span className="text-sm text-gray-500">Loading locations...</span>
      </div>
    );
  }

  return (
    <BoardSelector
      boards={locationBoards}
      selectedIds={selectedLocationIds}
      onSelectionChange={handleSelectionChange}
      placeholder={placeholder}
      className={cn("min-w-[280px]", className)}
      showSummary={showSummary}
      showSelectAll={showSelectAll}
    />
  );
};

export default LocationSelector;